import React, { useEffect, useState } from 'react'
import Address from "../tags/Address";
import HelpText from "../tags/HelpText";
import {
  getDefaultContactAddress,
  getTooltipBySlug,
  //handleAustralianAddressKnowledgeChange,
  isInternationalOnshoreStudent,
  isDomesticStudent,
  mergeContactDetails,
} from "../../helpers/form";
import {
  isValidCountryForPermanentResidencyType,
  isValidCountryForContactResidencyType,
  hasCharCountLessThanOrEqualTo,
  isNotEmpty,
  isValidAustralianHomeNumber,
  isValidAustralianMobileNumber,
  isValidEmail,
  isValidEmailDomain,
  isValidInternationalHomeNumber,
  isValidInternationalMobileNumber,
  isValidInternationalNumber,
  isValidPermanentAustralianPostcode,
  isValidPermanentAustralianState,
  isValidPermanentAustralianSuburb,
  isValidPermanentCountry,
  isValidPermanentInternationalPostcode,
  isValidPermanentInternationalState,
  isValidPermanentInternationalSuburb,
  isValidContactAddressLine1,
  isValidContactAddressLine2,
  isValidContactAddressLine3,
  isValidContactAustralianPostcode,
  isValidContactAustralianState,
  isValidContactAustraliaSuburb,
  isValidContactCountry,
  isValidContactInternationalPostcode,
  isValidContactInternationalState,
  isValidContactInternationalSuburb,
  isValidEdgesCharacter,
  isValidCharacters,
  isValidAddressCharacters,
  isDummyTest
} from '../../helpers/validation'
import { getTooltipsForPage } from "../../services/reservoir";
import Country from "../../enums/Country";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";

import * as Yup from 'yup';

const ConfirmDetailsForm = props => {
  const validationSchema = Yup.object().shape({
    preferredName: Yup.string()
      .required('Name should not be empty.')
      .test('charCount', 'Name must be less than 30 characters long.', (value, context) => hasCharCountLessThanOrEqualTo(value, 30))
      .test('isValidEdgesCharacter', 'It must start and end with a letter (A-Z a-z).', (value, context) => isValidEdgesCharacter(value))
      .test('isValidCharacters', 'Please use only letters, spaces, apostrophes, or hyphens.', (value, context) => isValidCharacters(value)),
    
    mobileNumber: Yup.string()
      .test('isValidAustralianMobileNumber', 'Please enter a valid 10 digit Australian phone number.', (value, context) => isValidAustralianMobileNumber(value, context))
      .test('isValidInternationalMobileNumber', 'Overseas phone numbers must be between 1 and 20 characters long.', (value, context) => isValidInternationalMobileNumber(value, context)),
    
    homePhoneNumber: Yup.string()
      .test('isValidAustralianHomeNumber', 'Please enter in a valid Australian phone number.', (value, context) => isValidAustralianHomeNumber(value, context))
      .test('isValidInternationalHomeNumber', 'Overseas phone numbers must be between 1 and 20 characters long.', (value, context) => isValidInternationalHomeNumber(value, context)),
    
    emailAddress: Yup.string()
      .required('Email should not be empty.')
      .max(100, 'Email address must be less than 100 characters long.')
      .test('Email address must be valid.', (value, context) => isValidEmail(value))
      .test('isValidEmailDomain', 'Personal email cannot be a VU email address. Please enter an alternative personal email address.', (value, context) => isValidEmailDomain(value)),
    
    permanentCountry: Yup.string()
      .test('isValidPermanentCountry', 'Please enter a valid country.', (value, context) => isValidPermanentCountry(value, props.countryCodes))
      .test('isValidCountryForPermanentResidencyType', 'Please enter a valid country.', (value, context) => isValidCountryForPermanentResidencyType(value, context)),
    
    permanentAddressLine1: Yup.string()
      .required('Address should not be empty.')
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value))
      .test('isValidPermanentAddressLine1', 'Street address must be less than 50 characters long.', (value, context) => hasCharCountLessThanOrEqualTo(value, 50)),
    
    permanentAddressLine2: Yup.string()
      .test('permanentAddressLine2', 'Address name must be less than 50 characters long.', (value, context) => hasCharCountLessThanOrEqualTo(value, 50))
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value)),
    
    permanentAddressLine3: Yup.string()
      .test('permanentAddressLine2', 'Address name must be less than 50 characters long.', (value, context) => hasCharCountLessThanOrEqualTo(value, 50))
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value)),
    
    permanentSuburb: Yup.string()
      .test('isValidPermanentAustraliaSuburb', 'Please provide a valid Australian suburb.', (value, context) => isValidPermanentAustralianSuburb(value, context))
      .test('isValidPermanentInternationalSuburb', 'Please provide a valid suburb.', (value, context) => isValidPermanentInternationalSuburb(value, context)),
    
    permanentState: Yup.string()
      .test('isValidPermanentAustralianState', 'Please select a valid state.', (value, context) => isValidPermanentAustralianState(value, context))
      .test('isValidPermanentInternationalState', 'Overseas states must be less than 40 characters.', (value, context) => isValidPermanentInternationalState(value, context)),
    
    permanentPostcode: Yup.string()
      .test('isValidPermanentAustralianPostcode', 'Australian postcodes must be 4 digits.', (value, context) => isValidPermanentAustralianPostcode(value, context))
      .test('isValidPermanentInternationalPostcode', 'Overseas postcodes must be less than 10 characters.', (value, context) => isValidPermanentInternationalPostcode(value, context)),
    
    contactCountry: Yup.string()
      .test('isValidContactCountry', 'Please enter a valid country.', (value, context) => isValidContactCountry(value, context, props.countryCodes))
      .test('isValidCountryForContactResidencyType', 'Please enter a valid country.', (value, context) => isValidCountryForContactResidencyType(value, context)),
    
    contactAddressLine1: Yup.string()
      .test('isValidContactAddressLine1', 'Street address must be less than 50 characters long.', (value, context) => isValidContactAddressLine1(value, context))
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value)),
    
    contactAddressLine2: Yup.string()
      .test('isValidContactAddressLine2', 'Please provide a street address that is less than 50 characters long.', (value, context) => isValidContactAddressLine2(value, context))
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value)),
    
    contactAddressLine3: Yup.string()
      .test('isValidContactAddressLine3', 'Please provide a address that is less than 50 characters long.', (value, context) => isValidContactAddressLine3(value, context))
      .test('isValidAddressCharacters', 'Please use only letters, numbers, spaces, and basic punctuation.', (value, context) => isValidAddressCharacters(value)),
    
    contactSuburb: Yup.string()
      .test('isValidContactAustraliaSuburb', 'Please provide a valid Australian suburb.', (value, context) => isValidContactAustraliaSuburb(value, context))
      .test('isValidContactInternationalSuburb', 'Please provide a valid suburb.', (value, context) => isValidContactInternationalSuburb(value, context)),
    
    contactState: Yup.string()
      .test('isValidContactAustralianState', 'Please select a valid state.', (value, context) => isValidContactAustralianState(value, context))
      .test('isValidContactInternationalState', 'Overseas states must be less than 40 characters.', (value, context) => isValidContactInternationalState(value, context)),
    
    contactPostcode: Yup.string()
      .test('isValidContactAustralianPostcode', 'Australian postcodes must be 4 digits.', (value, context) => isValidContactAustralianPostcode(value, context))
      .test('isValidContactInternationalPostcode', 'Overseas postcodes must be less than 10 characters.', (value, context) => isValidContactInternationalPostcode(value, context)),
    
    contactName: Yup.string()
      .required('Contact name should not be empty.')
      .test('charCount', 'Contact name must be less than 40 characters long.', (value, context) => hasCharCountLessThanOrEqualTo(value, 40))
      .test('isValidEdgesCharacter', 'It must start and end with a letter (A-Z a-z).', (value, context) => isValidEdgesCharacter(value))
      .test('isValidCharacters', 'Please use only letters, spaces, apostrophes, or hyphens.', (value, context) => isValidCharacters(value)),
    
    contactNumber: Yup.string()
      .test('isValidInternationalNumber', 'Contact number must be between 1 and 20 characters long.', (value, context) => isValidInternationalNumber(value)),
    
    contactRelationship: Yup.string()
      .required('Contact relationship should not be empty.'),
  })

  const [tooltips, setTooltips] = useState([])
  const [form, setForm] = useState({
    preferredName: '',
    chosenFirstName: '',
    chosenLastName: '',
    chosenPronouns: '',
    chosenAffirmedGender: '',
    mobileNumber: '',
    homePhoneNumber: '',
    emailAddress: '',

    permanentCountry: '',
    permanentAddressLine1: '',
    permanentAddressLine2: '',
    permanentAddressLine3: '',
    permanentSuburb: '',
    permanentState: '',
    permanentPostcode: '',
    permanentHasAddressChanged: false,
    insertPermanentAddressManually: false,

    knowsAustralianAddress: "N",
    contactAddressSameAsPermanentAddress: false,
    contactCountry: '',
    contactAddressLine1: '',
    contactAddressLine2: '',
    contactAddressLine3: '',
    contactSuburb: '',
    contactState: '',
    contactPostcode: '',
    contactHasAddressChanged: false,
    insertContactAddressManually: false,

    contactName: '',
    contactNumber: '',
    contactRelationship: '',
    citizenshipCode: '',
    offshoreFlag: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(()=> {
    setForm(props.values)
    getTooltipsForPage("Confirm Details").then((tooltips) => {
      setTooltips(tooltips.data)
    });
  },[])


  const handleChange = async (e) => {

    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value
    });

    try {
      await validationSchema.validateAt(name, { ...form, [name]: value }, { context: {"form": form} });
      setErrors({
        ...errors,
        [name]: undefined
      });
    } catch (validationError) {
      setErrors({
        ...errors,
        [name]: validationError.message
      });
    }
  };

  const handleCountryChange = (countryFieldName, countryCode) => {

    if (countryFieldName === 'permanentCountry' && countryCode) {
      setForm({
        ...form,
        permanentCountry: countryCode,
        permanentAddressLine1: '',
        permanentAddressLine2: '',
        permanentAddressLine3: '',
        permanentSuburb: '',
        permanentState: '',
        permanentPostcode: '',
        permanentLatitude: 0,
        permanentLongitude: 0,
        permanentVerificationDate: '',
        permanentValidationStatus: 'MANUAL'
      })
    }

    if (countryFieldName === 'contactCountry' && countryCode) {
      setForm({
        ...form,
        contactCountry: countryCode,
        contactAddressLine1: '',
        contactAddressLine2: '',
        contactAddressLine3: '',
        contactSuburb: '',
        contactState: '',
        contactPostcode: '',
        contactLatitude: 0,
        contactLongitude: 0,
        contactVerificationDate: '',
        contactValidationStatus: 'MANUAL'
      })
    }

  }

  const handleInsertAddressManually = event => {

    const { name, checked } = event.target;


    if (name === 'insertPermanentAddressManually') {
      setForm({
        ...form,
        permanentLatitude: form.insertPermanentAddressManually ? 0 : form.permanentLatitude,
        permanentLongitude: form.insertPermanentAddressManually ? 0 : form.contactLongitude,
        permanentVerificationDate: checked ? '' : form.permanentVerificationDate,
        permanentValidationStatus: checked ? 'MANUAL' : form.permanentValidationStatus,
        insertPermanentAddressManually: checked
      })
    }

    if (name === 'insertContactAddressManually') {
      setForm({
        ...form,
        contactLatitude: form.insertContactAddressManually ? 0 : form.contactLatitude,
        contactLongitude: form.insertContactAddressManually ? 0 : form.contactLongitude,
        contactVerificationDate: checked ? '' : form.contactVerificationDate,
        contactValidationStatus: checked ? "MANUAL" : form.contactValidationStatus,
        insertContactAddressManually: checked
      })
    }
  }

  const handleAddressValidation = ({ addressLine1, addressLine2, addressLine3, city, state, postCode, country, longitude, latitude, verificationDate, validationStatus }, name) => {

    if(name === 'permanentAddressValidator') {
      setForm({
        ...form,
        permanentAddressLine1: addressLine1,
        permanentAddressLine2: addressLine2,
        permanentAddressLine3: addressLine3,
        permanentSuburb: city,
        permanentState: state,
        permanentPostcode: postCode,
        permanentLatitude: latitude || 0,
        permanentLongitude: longitude || 0,
        permanentVerificationDate: verificationDate || '',
        permanentValidationStatus: validationStatus,
        insertPermanentAddressManually: false
      })
    } else {
      setForm({
        ...form,
        contactAddressLine1: addressLine1,
        contactAddressLine2: addressLine2,
        contactAddressLine3: addressLine3,
        contactSuburb: city,
        contactState: state,
        contactPostcode: postCode,
        contactLatitude: latitude || 0,
        contactLongitude: longitude || 0,
        contactVerificationDate: verificationDate || '',
        contactValidationStatus: validationStatus,
        insertContactAddressManually: false
      })
    }
  }

  const handleSameAsPermanentChange = event => {

    const { name, checked } = event.target;

    if (!checked) {
      const contactAddress = getDefaultContactAddress(props.autofillAddresses)
      if (contactAddress) {
        setForm({
          ...form,
          [name]: checked,
          ...mergeContactDetails(contactAddress)
        })
      }
    } else {
      setForm({
        ...form,
        [name]: checked,
      })
    }
  }

  const handleAustralianAddressKnowledgeChange = async (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      knowsAustralianAddress: value,
      contactAddressSameAsPermanentAddress:
        value === "Y" ? false : value.contactAddressSameAsPermanentAddress
    })
  }

  const showContactAddress = () => {
    return (
      (isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) &&
        form.knowsAustralianAddress === "Y") ||
      !(
        isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) ||
        form.contactAddressSameAsPermanentAddress
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await validationSchema.validate(form, { context: form, abortEarly: false });
      setErrors({});
      props.handleSubmit({form: form, valid: true, errors: {}})
    } catch (validationErrors) {
      const formattedErrors = validationErrors.inner.reduce((acc, error) => {
        return { ...acc, [error.path]: error.message };
      }, {});
      setErrors(formattedErrors);
      props.handleSubmit({form: form, valid: false, errors: formattedErrors})
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="formGroup question-group">
        <HelpText
          tag={"h3"}
          text={"What do you prefer to be called?"}
          toolTip={getTooltipBySlug("preferred-name", tooltips)}
        />
        <div className="row">
          <div>
            <TextField
              error={!!errors.preferredName}
              helperText={errors.preferredName}
              label="Preferred name"
              fullWidth
              maxLength={30}
              name="preferredName"
              onChange={handleChange}
              value={form.preferredName || ""}
              autoComplete="given-name"
              variant="standard"
            />
          </div>
        </div>
      </div>
      <div className="formGroup question-group">
        <h2>Contact details</h2>
        <div className="row">
          <div>
            <TextField
              error={!!errors.mobileNumber}
              helperText={errors.mobileNumber}
              label="Mobile number"
              fullWidth
              name="mobileNumber"
              onChange={handleChange}
              type="tel"
              value={form.mobileNumber || ""}
              autoComplete="tel"
              variant="standard"
            />
          </div>
          <div>
            <TextField
              error={!!errors.homePhoneNumber}
              helperText={errors.homePhoneNumber}
              label="Home phone number (optional)"
              fullWidth
              name="homePhoneNumber"
              onChange={handleChange}
              type="tel"
              value={form.homePhoneNumber || ""}
              autoComplete="tel"
              variant="standard"
            />
          </div>
        </div>
        <div className="row">
          <div>
            <TextField
              error={!!errors.emailAddress}
              helperText={errors.emailAddress}
              label="Personal email"
              fullWidth
              name="emailAddress"
              onChange={handleChange}
              type="email"
              value={form.emailAddress || ""}
              autoComplete="email"
              variant="standard"
            />
          </div>
        </div>
      </div>
      <h2>Address details</h2>
      <div className="formGroup question-group">
        <HelpText
          tag={"h3"}
          text={"Permanent home address"}
          toolTip={getTooltipBySlug(
            "permanent-home-address",
            tooltips
          )}
        />

        <Address
          allowedCountries={
            isDomesticStudent(form.stuCitizenCd)
              ? "AUS"
              :  isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag)
                ? "OVERSEAS"
                : "ALL"
          }
          country={form.permanentCountry}
          countryName="permanentCountry"
          countryOnChange={handleCountryChange}
          countryErrors={errors.permanentCountry}
          insertAddressManually={form.insertPermanentAddressManually}
          insertAddressManuallyName="insertPermanentAddressManually"
          handleInsertAddressManuallyChange={handleInsertAddressManually}
          addressValidatorName="permanentAddressValidator"
          handleAddressValidation={handleAddressValidation}
          currentValidationStatus={form.permanentValidationStatus}
          showInvalidAddressAlert={props.hasAttemptedToSave}
          addressLine1={form.permanentAddressLine1}
          addressLine1Name="permanentAddressLine1"
          addressLine1Errors={errors.permanentAddressLine1}
          addressLine1OnChange={handleChange}
          addressLine2={form.permanentAddressLine2}
          addressLine2Name="permanentAddressLine2"
          addressLine2Errors={errors.permanentAddressLine2}
          addressLine2OnChange={handleChange}
          addressLine3={form.permanentAddressLine3}
          addressLine3Name="permanentAddressLine3"
          addressLine3Errors={errors.permanentAddressLine3}
          addressLine3OnChange={handleChange}
          city={form.permanentSuburb}
          cityName="permanentSuburb"
          cityErrors={errors.permanentSuburb}
          cityOnChange={handleChange}
          state={form.permanentState}
          stateName="permanentState"
          stateErrors={errors.permanentState}
          stateOnChange={handleChange}
          postcode={form.permanentPostcode}
          postcodeName="permanentPostcode"
          postcodeErrors={errors.permanentPostcode}
          postcodeOnChange={handleChange}
          excludedCountries={props.excludedCountries}
        />
      </div>

      {isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) && (
        <div className="question-group">
          <HelpText
            tag="h3"
            text="Do you know where you will be living in Australia?"
          />
          <div className="form-items-group">
            <div className="formGroup formGroup--narrow">
              <RadioGroup
                className="row"
                name="knowsAustralianAddress"
                onChange={handleAustralianAddressKnowledgeChange}
                value={form.knowsAustralianAddress}
              >
                <FormControlLabel label="Yes" value={"Y"} control={<Radio/>} />
                <FormControlLabel label="No" value={"N"} control={<Radio/>} />
              </RadioGroup>
            </div>
          </div>

          {form.knowsAustralianAddress === "N" ? (
            <div className="sidenote sidenote--warning">
              <div className="sidenote__content">
                <p>
                  <strong>Important:</strong> You need to provide your
                  Australian address to comply with your visa conditions.
                  Please ensure you provide your address details within seven
                  days of arriving in Australia. If you change your address
                  while in Australia, you are required to provide details of
                  your new address within seven days of moving.
                </p>
              </div>
            </div>
          ) : null}
        </div>
      )}

      <div className="formGroup question-group">
        {(! isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) ||
          ( isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) &&
            form.knowsAustralianAddress === "Y")) && (
          <div>
            <HelpText
              tag={"h3"}
              text={"Contact address"}
              toolTip={getTooltipBySlug(
                "contact-address",
                tooltips,
              )}
            />
          </div>
        )}
        <div className="form-items-group">
          {!isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) ? (
            <FormGroup>
              <FormControlLabel
                label="Same as permanent address"
                control={
                  <Checkbox
                    name="contactAddressSameAsPermanentAddress"
                    className="checkbox postalSameAsPermanent"
                    checked={form.contactAddressSameAsPermanentAddress}
                    onChange={handleSameAsPermanentChange}
                  />
                }
              />
            </FormGroup>
          ) : null}
        </div>

        <Address
          allowedCountries={
            isInternationalOnshoreStudent(form.stuCitizenCd, form.offshoreFlag) || isDomesticStudent(form.stuCitizenCd)
              ? "AUS"
              : "ALL"
          }
          enabled={showContactAddress()}
          country={form.contactCountry}
          countryName="contactCountry"
          countryOnChange={handleCountryChange}
          countryErrors={errors.contactCountry}
          insertAddressManually={form.insertContactAddressManually}
          insertAddressManuallyName="insertContactAddressManually"
          handleInsertAddressManuallyChange={handleInsertAddressManually}
          addressValidatorName="contactAddressValidator"
          handleAddressValidation={handleAddressValidation}
          currentValidationStatus={form.contactValidationStatus}
          showInvalidAddressAlert={props.hasAttemptedToSave}
          addressLine1={form.contactAddressLine1}
          addressLine1Name="contactAddressLine1"
          addressLine1Errors={errors.contactAddressLine1}
          addressLine1OnChange={handleChange}
          addressLine2={form.contactAddressLine2}
          addressLine2Name="contactAddressLine2"
          addressLine2Errors={errors.contactAddressLine2}
          addressLine2OnChange={handleChange}
          addressLine3={form.contactAddressLine3}
          addressLine3Name="contactAddressLine3"
          addressLine3Errors={errors.contactAddressLine3}
          addressLine3OnChange={handleChange}
          city={form.contactSuburb}
          cityName="contactSuburb"
          cityErrors={errors.contactSuburb}
          cityOnChange={handleChange}
          state={form.contactState}
          stateName="contactState"
          stateErrors={errors.contactState}
          stateOnChange={handleChange}
          postcode={form.contactPostcode}
          postcodeName="contactPostcode"
          postcodeErrors={errors.contactPostcode}
          postcodeOnChange={handleChange}
          excludedCountries={props.excludedCountries}
        />
      </div>
      <h2>Emergency contact</h2>
      <div className="formGroup question-group">
        <div className="row">
          <div>
            <TextField
              error={!!errors.contactName}
              helperText={errors.contactName}
              label="Contact name"
              fullWidth
              maxLength={40}
              name="contactName"
              onChange={handleChange}
              type="text"
              value={form.contactName || ""}
              variant="standard"
            />
          </div>
        </div>
        <div className="row">
          <div>
            <TextField
              error={!!errors.contactNumber}
              helperText={errors.contactNumber}
              label="Contact number"
              fullWidth
              name="contactNumber"
              onChange={handleChange}
              type="tel"
              value={form.contactNumber || ""}
              variant="standard"
            />
          </div>
          <div>
            <FormControl variant="standard" fullWidth>
              <InputLabel
                id="contact-relationship-select"
                error={!!errors.contactRelationship}
              >
                Relationship
              </InputLabel>
              <Select
                labelId="contact-relationship-select"
                //required={true}
                error={!!errors.contactRelationship}
                // className={
                //   !!errors.contactRelationship
                //     ? "form-error"
                //     : ""
                // }
                label="Relationship"
                name="contactRelationship"
                value={form.contactRelationship || ''}
                options={props.emergencyContactOptions}
                onChange={handleChange}
              >
                {!props.emergencyContactOptions.length
                  ? null
                  : props.emergencyContactOptions.map(
                      (relationship) => {
                        return (
                          <MenuItem
                            key={relationship.code}
                            value={relationship.code}
                          >
                            {relationship.description}
                          </MenuItem>
                        );
                      },
                    )}
              </Select>
            </FormControl>

            {!!errors.contactRelationship ? (
              <FormHelperText htmlFor="contact-relationship-select" error>
                {errors.contactRelationship}
              </FormHelperText>
            ) : (
              false
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-6">
          {props.saving ? (
            <button className="btn btn-lg btn-primary" disabled>
              Submitting...
            </button>
          ) : (
            <button className="btn btn-lg btn-primary">
              Submit &amp; continue
            </button>
          )}
        </div>
      </div>
    </form>
  );
  
}

export default ConfirmDetailsForm;
